





/**
 * Provides the current traffic model id which is the traffic model number needed for the Traffic API -
 * Incidents Layer, and the {{#crossLink "TrafficIncidents"}}Traffic API - Incident Details{{/crossLink}}
 * calls.
 *
 * It is updated every minute, and is valid for two minutes before it times out.
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "TrafficModelId/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "TrafficModelId/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class TrafficModelId
 * @uses Chain
 * @module Services
 * @uses KeyMixin
 * @uses ProtocolMixin
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 *
 * @example
 * ```js
 * function callbackFn(response) {
 *   console.log(response);
 * }
 * tomtom.trafficModelId()
 *   .key("<Your API key>")
 *   .go(callbackFn);
 * ```
 */
define(['rest/trafficViewport', 'model/traffic/trafficModelId', './chain', './validators'],
    function(restTrafficViewport, model, chain, validators) {
        'use strict';

        var fields = {
            key: {validator: validators.string},
            protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')}
        };

        var trafficViewport = restTrafficViewport();

        function handleChain(data, callback) {
            trafficViewport.trafficViewport(fields, data, function(response) {
                callback.call(this, model(response));
            });
        }

        return function(options) {
            return chain(fields, handleChain, options);
        };
    }
);



// WEBPACK FOOTER //
// ./services/trafficModelId.js